import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faSchool, faHashtag, faBook, faMapMarkerAlt, faThLarge, faPiggyBank, faCodeBranch, faCreditCard, faAddressCard, faSitemap, faMap, faMapPin, faPhone, faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons';
import { Container, Button } from 'react-bootstrap';

function RegisterForm({ onSubmit, register, errors, handleSubmit, trigger }) {
    const [currentStep, setCurrentStep] = useState(1);
    const totalSteps = 4;

    const getStepFields = (step) => {
        switch (step) {
            case 1:
                return ['brc_full_name', 'school_name', 'school_dice_code', 'rojmel_name', 'cluster_name'];
            case 2:
                return ['block_name', 'sub_division', 'district', 'pincode', 'address'];
            case 3:
                return ['bank_name', 'bank_branch_name', 'bank_account_no'];
            case 4:
                return ['mobile_no', 'business_email', 'password'];
            default:
                return [];
        }
    };

    const nextStep = async () => {
        const currentFields = getStepFields(currentStep);
        const valid = await trigger(currentFields);
        if (valid) {
            if (currentStep < totalSteps) {
                setCurrentStep(currentStep + 1);
            }
        }
    };

    const prevStep = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };

    const renderStepContent = () => {
        let fields = [];
        switch (currentStep) {
            case 1:
                fields = [
                    { name: 'brc_full_name', placeholder: 'BRC/CRC/SMC/SMDC/KGBV', icon: faUser },
                    { name: 'school_name', placeholder: 'School Name', icon: faSchool },
                    { name: 'school_dice_code', placeholder: 'School Dise Code', icon: faHashtag },
                    { name: 'rojmel_name', placeholder: 'Rojmel Name', icon: faBook },
                    { name: 'cluster_name', placeholder: 'Cluster Name', icon: faMapMarkerAlt },
                ];
                break;
            case 2:
                fields = [
                    { name: 'block_name', placeholder: 'Block Name', icon: faThLarge },
                    { name: 'address', placeholder: 'Address', icon: faAddressCard },
                    { name: 'district', placeholder: 'District', icon: faMap },
                    { name: 'sub_division', placeholder: 'Taluko', icon: faSitemap },
                    { name: 'pincode', placeholder: 'Pincode', icon: faMapPin, pattern: /^[0-9]{6}$/, patternMessage: "Invalid pincode format (6 digits required)" },
                ];
                break;
            case 3:
                fields = [
                    { name: 'bank_name', placeholder: 'Bank Name', icon: faPiggyBank },
                    { name: 'bank_branch_name', placeholder: 'Bank Branch Name', icon: faCodeBranch },
                    { name: 'bank_account_no', placeholder: 'Bank Account Number', icon: faCreditCard, pattern: /^[0-9]+$/, patternMessage: "Bank Account number must contain only digits", minLength: 9, maxLength: 18, minLengthMessage: "Bank Account number must be at least 9 digits", maxLengthMessage: "Bank Account number cannot exceed 18 digits" },
                ];
                break;
            case 4:
                fields = [
                    { name: 'mobile_no', placeholder: 'Mobile Number', icon: faPhone, pattern: /^[0-9]+$/, patternMessage: "Mobile Number must contain only digits", minLength: 10, maxLength: 12, minLengthMessage: "Mobile Number must be at least 10 digits", maxLengthMessage: "Mobile Number cannot exceed 12 digits" },
                    { name: 'business_email', placeholder: 'Email', icon: faEnvelope, pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, patternMessage: "Invalid email address format" },
                    { name: 'password', placeholder: 'Password', icon: faLock, minLength: 8, minLengthMessage: "Password must be at least 8 characters" },
                ];
                break;
            default:
                return <div>પગલાની સામગ્રી મળી નથી</div>;
        }

        return fields.map((field) => (
            <div key={field.name} className="input-group mb-3">
                <input
                    type={field.name === 'password' ? 'password' : field.name === 'business_email' ? 'email' : 'text'}
                    className={`form-control ${errors[field.name]?.message ? 'is-invalid' : ''}`}
                    placeholder={field.placeholder}
                    name={field.name}
                    {...register(field.name, {
                        required: `${field.placeholder} is required`,
                        pattern: field.pattern ? { value: field.pattern, message: field.patternMessage } : undefined,
                        minLength: field.minLength ? { value: field.minLength, message: field.minLengthMessage } : undefined,
                        maxLength: field.maxLength ? { value: field.maxLength, message: field.maxLengthMessage } : undefined,
                    })}
                />
                <div className="input-group-append">
                    <div className="input-group-text">
                        <FontAwesomeIcon icon={field.icon} />
                    </div>
                </div>
                {errors[field.name] && <span className="invalid-feedback">{errors[field.name].message}</span>}
            </div>
        ));
    };

    const handleRegister = async (data) => {
        const valid = await trigger();
        if (valid) {
            onSubmit(data);
        }
    };

    const handleRegisterClick = () => {
        handleSubmit(handleRegister)();
    };

    return (
        <Container>
            <div className="card-body">
                <p className="login-box-msg">Create your account to experience east and organized accounting.</p>
                <form>
                    {renderStepContent()}
                </form>
                <div className="mt-3 d-flex justify-content-between">
                    {currentStep > 1 && (
                        <Button variant="secondary" onClick={prevStep} type="button">
                            Previous
                        </Button>
                    )}
                    {currentStep < totalSteps ? (
                        <Button variant="primary" onClick={nextStep} type="button">
                            Next
                        </Button>
                    ) : (
                        <Button variant="primary" onClick={handleRegisterClick} type="button">
                            Create
                        </Button>
                    )}
                </div>
                <p className="mt-3 mb-1">
                    <Link to="/login" className="text-center">
                        Already have an account? Sign In
                    </Link>
                </p>
            </div>
        </Container>
    );
}

export default RegisterForm;